import { render } from "./InvoicingInvoiceInfosComponent.vue?vue&type=template&id=1ebd0a28"
import script from "./InvoicingInvoiceInfosComponent.vue?vue&type=script&lang=js"
export * from "./InvoicingInvoiceInfosComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__